import { FastCalculator } from "@tm/data"
import { CSVRowData } from "../model"

function parseRow(rowData: CSVRowData): FastCalculator.CalcOeNumber {
    return {
        Number: rowData.ArtNrOE,
        GenArtBez: rowData.Bez,
        GenArtNr: rowData.GenArt ? Number(rowData.GenArt) : null,
        Quantity: Number(rowData.Menge),
        Price: parseFloat(rowData.Preis.replace("€", "").replace(",", ".").trim()),
    }
}

export function parseCSV(csvRows: CSVRowData[]) {
    return csvRows.map(parseRow)
}
